export default __webpack_public_path__ + "static/media/secondcard.b80326bf.jpg";